<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('founder.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'founder' }">{{ $t('founder.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <second-anniversary-memorial-ceremony v-if="current_anniversary == 2"></second-anniversary-memorial-ceremony>
    <third-anniversary-memorial-ceremony v-if="current_anniversary == 3"></third-anniversary-memorial-ceremony>
    <fourth-anniversary-memorial-ceremony v-if="current_anniversary == 4"></fourth-anniversary-memorial-ceremony>
    <div class="row">
      <div class="col-12"><hr></div>
    </div>
    <div class="row">
      <div class="col-12">
        <h5 class="text-center">
          <a href="https://www2.budaedu.org/dharma-data/book-efile/CH282-10-01-001.PDF">本會書籍電子檔：老和尚的身教</a>
        </h5>
        <b-img center src="https://www2.budaedu.org/dharma-data/book-cover/CH28210.jpg" fluid></b-img>
      </div>
    </div>
    <div class="row">
      <div class="col-12"><hr></div>
    </div>
    <div class="row">
      <div class="col-12">
        <h5 class="text-center">
          <sup>上</sup>淨<sup>下</sup>空老和尚生平簡介
        </h5>
        <div v-html="lecturer.intro"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'

import SecondAnniversaryMemorialCeremony from './anniversary-memorial-ceremony/SecondAnniversary.vue'
import ThirdAnniversaryMemorialCeremony from './anniversary-memorial-ceremony/ThirdAnniversary.vue'
import FourthAnniversaryMemorialCeremony from './anniversary-memorial-ceremony/FourthAnniversary.vue'

import LecturerApiService from '@/services/budaedu-api-services/lecturer-api-service.js'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)

Vue.use(LecturerApiService)

export default {
  i18n,
  name: "founder",
  props: {
    // 
  },
  data() {
    return {
      current_anniversary: 4,
      lecturer_id: 38,
      lecturer: null
    }
  },
  methods: {
    async setLecturer() {
      const item = await this.$lecturerApiService.getById(this.lecturer_id)
      this.lecturer = item.data
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    this.setLecturer()
  },
  components: {
    SecondAnniversaryMemorialCeremony,
    ThirdAnniversaryMemorialCeremony,
    FourthAnniversaryMemorialCeremony
  },
  metaInfo() {
    return {
      title: this.$t('founder.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$t('founder.description')
      }]
    }
  }
}
</script>